import React from 'react'
import { Breadcrumb } from 'antd'

function Bread({ text }) {
    return (
        <Breadcrumb style={{ margin: "20px 0" }}>
            <Breadcrumb.Item><a href="/">首页</a></Breadcrumb.Item>
            <Breadcrumb.Item>{text}</Breadcrumb.Item>
        </Breadcrumb>
    )
}

export default Bread
